/*eslint perfectionist/sort-objects: "error"*/
/* eslint-disable no-multi-str */

export const enGb = {
  account_number_sort_code: "Account Number and Sort Code",
  accountIdentifier: "Account identifier",
  accountNumber: "Account Number",
  accountNumberSortCode: "Account Number and Sort Code",
  accounts: "Accounts",
  actions: "Actions",
  activate: "Activate",
  activateCustomer: "Activate customer",
  activateCustomerDescription:
    "Are you sure you want to activate customer account? The Customer will be able to access Fuzebox and process transactions once integration is set.",
  activateOn: "Activate on",
  activatingYourBeneficiaryWillMean:
    "Activating your beneficiary will mean you will be able to accept payments through Volt into that account?",
  active: "Active",
  activeProducts: "Active products",
  add: "Add",
  addAddress: "Add address",
  addADynamicBeneficiary: "Add a Dynamic Beneficiary",
  addANewBeneficiary: "Add a new beneficiary",
  addANewCustomer: "Add a new customer",
  addBeneficiary: "Add a new beneficiary",
  addBeneficiary_plural: "Add {{count}} beneficiaries",
  addDynamicBeneficiary: "Add Dynamic Beneficiary",
  addedBy: "Added by",
  addEntry: "Add Entry",
  addNewDynamicBeneficiaries: "Add new dynamic beneficiaries",
  address: "Address",
  addressFor: "Address for {{name}}",
  addressLine2: "Address line 2",
  aliasValue: "Alias Value",
  allOfTheRealBankAccountsPopulated:
    "All of the real bank accounts have Bank Name populated.",
  allowStablecoinPayment: "Offer Pay with Stablecoin at checkout",
  apiAccess: "API Access",
  apply: "Apply",
  applyFiltersBeforeClose:
    "Before you close down the filter, do you want to leave without applying your filters?",
  areYouSureDeactivateCustomer:
    "Are you sure you want to deactivate this account? The customer will no longer be able to process transactions and access Fuzebox.",
  areYouSureYouWantProceedNotUsingVoltLicence:
    "Are you sure you want to proceed? Payments will no longer be processed using Volt PIS license, neither on Yapily, nor on PowerGrid.",
  areYouSureYouWantProceedUsingVoltLicence:
    "Are you sure you want to proceed? Payments will now be processed using Volt PIS license if applicable.",
  areYouSureYouWantToChangeStatus:
    "Are you sure you want to change the status?",
  areYouSureYouWantToRegenerate:
    "Are you sure you want to regenerate a password for the {{environment}} environment? Existing credentials will be immediately invalidated.",
  areYouSureYouWantToRemoveThisPublicKey:
    "Are you sure you want to remove this public key?",
  areYouSureYouWantToStopCustomerDeactivation:
    "Are you sure you want to stop the customer deactivation? The Customer will be able to continue as normal.",
  atMidnight: "at 23:59 UTC",
  aUnifiedSolutionForAll:
    "A unified solution for all of your treasury management needs. Our real-time orchestration engine, collects and reconciles funds, handles exceptions, and processes payouts, refunds and settlements",
  australia: "Australia",
  australiaAllowsReceivingPaymentsInAUD:
    "Australia as a product allows receiving payments on your website or app in AUD. It is processed using Australian market specific payment rails called PayTo.",
  authorized: "Authorized",
  backToDynamicBeneficiaries: "Back to dynamic beneficiaries",
  backToList: "Back to all customers",
  bankCode: "Bank Code",
  billing: "Billing",
  billingParent: "Billing parent",
  billingStartDate: "Billing start date",
  bsb: "BSB",
  buildingNumber: "Building number",
  cancel: "Cancel",
  changeDeactivationDate: "Change deactivation date",
  checkoutBranding: "Checkout branding",
  childCustomers: "Child customers",
  chooseDeactivationDate: "Choose deactivation date",
  chooseHowYouWantToSetUpYourSignatureKey:
    "Choose how you want to set up your signature key:",
  circuitBreaker: "Circuit Breaker",
  circuitBreakerHasBeenActivated: "Circuit Breaker has been activated",
  circuitBreakerHasBeenDeactivated: "Circuit Breaker has been deactivated",
  circuitBreakerMonitorsEveryTransaction:
    "Circuit Breaker monitors every transaction, using a flexible scoring system and responsive fraudster detection, to catch the fraud before it catches you.",
  city: "City",
  clear: "Clear",
  clearingOptimisation: "Clearing Optimisation",
  clearingOptimisationTooltip:
    "Optimise your settlement rate by processing payments only via banks that Volt identifies as having high clearing rates",
  clientId: "Client ID",
  clientSecret: "Client Secret",
  close: "Close",
  closedLoopPayouts: "Closed Loop Payouts",
  companyRegistrationNumber: "Company registration number",
  configurationDetailsProvider: "Configuration details - {{provider}}",
  configurationForAutomaticApproval:
    "Configuration for automatic approval of payouts and refunds when initiating via API.",
  configure: "Configure",
  configureASignatureKey: "Configure a signature key",
  configurePaymentsProviders: "Configure payments providers",
  configureProvider: "Configure {{provider}}",
  confirm: "Confirm",
  confirmHierarchyChanges: "Confirm hierarchy changes",
  connect: "Connect",
  connectOurRealTimeOrchestrationEngine:
    "Track open banking payments from initiation to receipt with complete visibility of the payment value chain. Connect, our real-time orchestration engine, collects and reconciles funds, handles exceptions, and processes payouts and refunds.",
  contactCustomerSupport: "contact customer support",
  continue: "Continue",
  contractingParty: "Contracting party",
  couldNotFetchAccountInfos: "Could not fetch account informations.",
  couldNotLoadPaymentProcessingLicenses:
    "Could not load payment processing licenses",
  couldNotLoadProviderConfiguration: "Could not load payment providers.",
  countries: "Countries",
  countriesFor: "Countries for {{customerName}}",
  countriesHaveBeenConfigured: "Countries have been configured.",
  country: "Country",
  createAPrivateKeyToSecurelySign:
    "Create a private key to securely sign your refund and payout requests. A corresponding public key will be generated to validate your signatures.",
  creationDate: "Creation date (UTC)",
  credentials: "Credentials",
  credentialsHasBeenGenerated: "Volt credentials has been generated",
  credentialsHasBeenRegenerated: "Volt credentials has been regenerated",
  currentlyViewedCustomer: "Currently viewed customer",
  customer: "Customer",
  customerAcceptsPayments:
    "This customer accepts payments from selected countries.",
  customerActivated: "Customer activated",
  customerAddress: "Customer address",
  customerAddressProvided: "Customer address provided.",
  customerDeactivated: "Customer deactivated",
  customerDetails: "Customer details",
  customerHasBeenCreated: "{{customerName}} has been created",
  customerName: "Customer {{name}}",
  customerNameCardLabel: "Customer name",
  customerNameLabel: "Customer name",
  customers: "Customers",
  customerStatus: "Customer status",
  customerStatusActive:
    "Active - customer can access Fuzebox and make payments",
  customerStatusDeactivated:
    "Deactivated - customer cannot access Fuzebox and also cannot make payments",
  customerType: "Customer Type",
  customerWasSaved: "{{customerName}} was saved",
  dateAdded: "Date added",
  deactivate: "Deactivate",
  deactivateCustomer: "Deactivate customer",
  deactivateImmediately: "Deactivate immediately",
  deactivatingYourBeneficiaryWillMean:
    "Deactivating your beneficiary will mean you will no longer be able to accept payments through Volt into that account?",
  deactivationDate: "Deactivation Date",
  deactivationDateCannotBeInThePast: "Deactivation date cannot be in the past",
  dedicatedAccountsForYourBusiness:
    "Dedicated accounts for your businesses and customers",
  details: "Details",
  disableVoltLicence: "Disable Volt PIS license",
  documentNumber: "Document number",
  doNotApplyFilters: "Don’t apply",
  dynamicBeneficiaries: "Dynamic beneficiaries",
  dynamicBeneficiariesHaveBeenUpdated: "Dynamic beneficiary has been updated",
  dynamicBeneficiariesHaveBeenUpdated_plural:
    "Dynamic beneficiaries have been updated",
  dynamicBeneficiariesUpdateFailed: "Dynamic beneficiaries update failed.",
  dynamicBeneficiariesWereUpdated: "Dynamic beneficiaries have been updated.",
  dynamicBeneficiary: "Dynamic beneficiary",
  edit: "Edit",
  editCustomer: "Edit customer",
  enableVoltLicence: "Enable Volt PIS license",
  enablingUnitedStatesWillAllowPaymentsInitiation:
    "Enabling United States will allow the initiation of payments, plus refunds and payouts, in USD. Payments will be processed using ACH and are not instant.",
  experienceTheConvenienceACH:
    "Experience the convenience of accessing funds on the very same day, provided transactions are initiated before the ACH cut-off time",
  expirationDate: "Expiration date",
  failedToLoadUsernames: "Failed to load usernames. Please, try again later.",
  fastTrackWithSameDayACH: "Fast-track transactions with Same Day ACH",
  filter: "Filter",
  findOutMore: "Find out more",
  fraudPreventionACH: "Fraud prevention for ACH payments",
  gateway: "Gateway",
  generalInformation: "General information",
  generateAKeyPair: "Generate a key pair",
  generateCredentials: "Generate credentials",
  givenCustomerCouldNotBeFound: "Given customer could not be found.",
  goToBeneficiaries: "Go to Beneficiaries",
  guestCheckoutOnly: "Guest checkout only",
  hierarchy: "Hierarchy",
  hierarchyChangesDetected:
    "Changes to the customer hierarchy have been detected. Please confirm you want to proceed.",
  iban: "IBAN",
  id: "ID",
  idRequiredToSignRefundAndPayoutRequest:
    "ID required to sign refund and payout requests",
  ignore: "Ignore",
  inactive: "Inactive",
  inactiveProducts: "Inactive products",
  incorporationDate: "Incorporation date",
  incorporationDateCompanyDocumentPopulated:
    "Incorporation date, company registration number and document number are all populated.",
  indicatesIfTheCurrentMerchantIsApprovedToProcessPayments:
    "Indicates if the current merchant is approved to process payments using Volt PIS licence. Determined and set by the compliance team.",
  integrator: "Integrator",
  integratorIsInheritedFromLoading:
    "Integrator is being inherited from <Loading />",
  integratorIsInheritedFromParent:
    "Integrator is being inherited from {{parent}}",
  integratorName: "Integrator Name",
  internalFx: "Internal FX",
  internalFXLetsYouConvertBalances:
    "Internal FX lets you convert balances between your accounts in different currencies",
  invalidPublicKey: "Invalid public key",
  issueClosedLoopPayoutsToYourShoppersFromYourVoltConnectAccount:
    "Issue closed loop payouts to your shoppers from your Volt Connect account",
  issueOpenLoopPayoutsToYourShoppersFromYourVoltConnectAccount:
    "Issue open loop payouts to your shoppers from your Volt Connect account",
  itsDesignedToGiveYouFullControl:
    "It's designed to give you full control over your multi-currency balances without needing external transfers or additional setup. Whether you’re consolidating funds, optimizing currency exposure, or preparing for payouts, Internal FX enables seamless, secure, and fast currency conversion across your Volt accounts.",
  iUnderstandThatThisIsTheOnlyTimeIWillSeeThisPassword:
    "I understand that this is the only time I will see this password, and I have copied it to a safe space.",
  iUnderstandThatThisIsTheOnlyTimeIWillSeeThisPrivateKey:
    "I understand that this is the only time I will see this private key, and I have copied it to a safe space. ",
  learnMoreAboutVoltProducts: "Learn about the other products Volt offers",
  legalName: "Legal name",
  listOfAllDependentCustomers: "List of all dependent customers ",
  machineLearningPoweredMatchmeter:
    "Machine learning-powered Matchmeter tool accurately matches naming nuances between merchant inputs and end-user bank records, producing a percentage match score.",
  manageAllYourEnabledProducts: "Manage all your enabled products",
  mandateManagement: "Mandate Management",
  mandateManagementLetsYouSetUpAndManageMandates:
    "Mandate Management lets you set up and manage mandates — a payer's one-time authorisation for future recurring payments — covering both PayTo (Australia) and VRP (UK Open Banking).",
  matchmeter: "Matchmeter",
  merchantCategoryCode: "Merchant category code",
  merchantCustomers: "Merchant customers",
  more: "+ {{numberOfInVisibleTags}} more",
  moreFiltersText: "+{{count}} more",
  name: "Name",
  namedAccounts: "Named Accounts",
  namedAccountsEnableYouToOffer:
    "Named Accounts enable you to offer dedicated accounts to the businesses and individuals on your platform. Each account is fully segregated, KYC-verified by Volt, and uniquely identifiable—ensuring every incoming payment is instantly and automatically reconciled without manual intervention.",
  newBeneficiary: "New beneficiary",
  newCustomer: "New customer",
  newKey: "New key",
  newSignatureKeyHasBeenAdded: "New signature key has been added",
  newVoltCredentials: "New Volt credentials",
  noAccountSelected: "No account selected",
  noCustomerFoundInThisHierarchy: "No customer found in this hierarchy",
  none: "None",
  nonExpiring: "Non-expiring",
  noParent: "No parent",
  noPublicKeys: "No public keys",
  noResults: "No results",
  notConfigured: "Not configured",
  notSet: "Not set",
  numDynamicBeneficiariesSelected: "{{count}} Dynamic Beneficiary selected",
  numDynamicBeneficiariesSelected_plural:
    "{{count}} Dynamic Beneficiaries selected",
  onePlatformForCollections:
    "One platform for collections, reconciliations, payouts, refunds, and settlements",
  onSelectedDateMerchantWillBeDeactivated:
    "On the selected date, the merchant's account and all child accounts will be deactivated. The Merchant will no longer be able to process payments via Volt, users will lose access to Fuzebox and transactional data so we suggest exporting this data in advance.",
  openLoopPayouts: "Open Loop Payouts",
  ourAIStool: "Our AIS tool",
  ourBINRecognitionTool: "Our BIN recognition tool",
  ourCashManagementSystem: "Our cash management system",
  ourCoreIntegration: "Our core integration",
  ourFraudPreventionTool: "Our fraud prevention tool",
  ourIntelligentNameMatching: "Our intelligent name matching",
  ourSolutionForAustralia: "Our solution for Australian market",
  ourSolutionForUS: "Our solution for US market",
  parent: "Parent",
  parentSubTppId: "Parent SubTppId",
  password: "Password",
  pasteYourPublicKeyHere:
    "Paste your public key here.  Include the BEGIN and END lines.",
  payByLink: "Pay by Link",
  payByLinkEnablesBusinessesToIntroduceOpenBankingPayments:
    "Pay by Link enables businesses to introduce open banking payments to all their communication channels with their customers. Clicking on the pre-generated link or scanning the QR code allows the customer to be redirected to Volt’s checkout page, where they can pay instantly using open banking-powered payments.",
  paymentConfiguration: "Payment configuration",
  paymentPreferences: "Payment preferences",
  paymentProcessingLicence: "Payment processing license",
  paymentProviderConfigured:
    "Payment provider {{name}} has been configured for the customer.",
  paymentProviders: "Payment providers",
  paymentProviderUpdated:
    "Payment provider {{name}} has been updated for the customer.",
  payments: "Payments",
  paymentSchemes: "Payment Schemes",
  paymentsProviders: "Payments providers",
  payouts: "Payouts",
  payoutsIsAFastAndReliablePaymentProcessingSolution:
    "Payouts is a fast and reliable payment processing solution that enables businesses to send money to individuals with ease.",
  pendingApprovalFromToken: "Pending approval from Token",
  "PIS: eCommerce merchant payment": "PIS: eCommerce merchant payment",
  "PIS: Funding an account": "PIS: Funding an account",
  "PIS: In store merchant payment": "PIS: In store merchant payment",
  "PIS: Paying a bill": "PIS: Paying a bill",
  "PIS: Paying off debt": "PIS: Paying off debt",
  pleaseCopyAndSecurely:
    "Please copy and securely store the credentials. Viewing the password will not be possible after closing this popup.",
  pleaseMakeSureThatYouHaveCopiedThePassword:
    "Please make sure that you have copied the password",
  pleaseMakeSureThatYouHaveCopiedThePrivateKey:
    "Please make sure that you have copied the private key",
  pleaseNoteThatPreviousCredentials:
    "Please note that previous credentials have already been invalidated and can no longer be used.",
  pleaseSelectParent:
    "Please select a parent to see the list of bank accounts this customer can inherit.",
  pleaseWaitAFewMomentsWhileWeSetUpPaymentProvidersAndCountriesItShouldntTakeLongerThanAMinute:
    "Please wait a few moments while we set up payment providers and countries. It shouldn’t take longer than a minute.",
  postalCode: "Postal code",
  postalZIPCode: "Postal / ZIP Code",
  primaryUseCase: "Primary Use Case",
  privateKey: "Private key",
  productFlagProductionModeHasBeenActivated:
    "{{productFlagName}} production mode has been activated",
  productFlagProductionModeHasBeenDeactivated:
    "{{productFlagName}} production mode has been deactivated",
  productFlagSandboxModeHasBeenActivated:
    "{{productFlagName}} sandbox mode has been activated",
  productFlagSandboxModeHasBeenDeactivated:
    "{{productFlagName}} sandbox mode has been deactivated",
  production: "Production",
  provideANameForThisPublicKey:
    "Provide a name for this public key, or we’ll generate one automatically",
  provideAnExpirationDateForThisPublicKey:
    "Provide an expiration date for this public key or leave blank for no expiry",
  provider: "Provider",
  provideValidBankCodes:
    "Provide valid bank codes to configure the list of allowed beneficiary banks.",
  publicKey: "Public key",
  publicKeyConfiguration: "Public key configuration for {{customerName}}",
  publicKeyId: "Public key id",
  publicKeyID: "Public key ID",
  reduceFraudWithSignal:
    "Reduce fraud with Signal's advanced machine learning, built on Plaid's trusted open banking network.",
  refundPaymentsReceivedOnYourVoltConnectAccount:
    "Refund payments received on your Volt Connect account",
  refunds: "Refunds",
  regenerate: "Regenerate",
  regenerateCredentials: "Regenerate credentials",
  regenerateCustomerCredentials:
    "Regenerate customer credentials for {{envName}} Environment?",
  regeneratedVoltCredentials: "Regenerated Volt credentials",
  regeneratePassword: "Regenerate password",
  regeneratingThePassword: "Regenerating the password",
  removingPublicKey: "Removing public key",
  requestIdHasBeenGenerated: "Request {{id}} has been generated.",
  requiredWhenInstructingRefundsAndPayoutsViaTheVoltAPI:
    "Required when instructing refunds and payouts via the Volt API, a shopping cart plugin or third-party provider.",
  requiresSetup: "Requires Setup",
  reset: "Reset",
  retry: "Retry",
  sameDayACH: "Same day ACH",
  sandbox: "Sandbox",
  save: "Save",
  saveChanges: "Save",
  select: "Select",
  selectCustomer: "Select customer",
  selectedCustomerHasBeenReset: "Selected customer has been reset",
  sendSecurePaymentLinks: "Send secure payment links",
  setActive: "Set Active",
  setInactive: "Set Inactive",
  setUpAndManageMandatesForRecurringPayments:
    "Set up and manage mandates for recurring payments",
  setUpDynamicBeneficiary: "Set up dynamic beneficiary",
  showLess: "Show Less",
  signal: "Signal",
  signatureKeyHasBeenDeleted: "Signature key {{name}} has been deleted",
  signatureKeys: "Signature keys",
  somethingWentWrong: "Something went wrong. Please try again later.",
  sort_code: "Sort Code",
  sortCode: "Sort code",
  stablecoinLayer:
    "Enable stablecoin pay-ins at checkout. Seamlessly process payments from consumers’ crypto wallets.",
  state: "State",
  stateRegionProvince: "State / Region / Province",
  status: "Status",
  stopDeactivation: "Stop deactivation",
  street: "Street",
  swift: "Swift code (BIC)",
  testCustomer: "Test customer",
  testCustomerConfirmDescription:
    "Test customers are internal, Volt-owned customers and are exempt from onboarding, AML checks etc. \
Use if you know exactly what you are doing.",
  testCustomerConfirmTitle: "Mark as test customer?",
  testCustomers: "Test customers",
  testCustomerSubtitle: "Marks as internal or test Volt-owned customer.",
  testCustomerTag: "TEST",
  theCredentialsRemainValidUntil:
    "The credentials remain valid until you regenerate the password, which immediately invalidates the old one. You may regenerate password at any time, if required.",
  theCustomerWillNoLonger:
    "The customer will no longer be able to process transactions or access Fuzebox after the selected date.",
  thereAreMoreFiltersItems: "There is {{count}} more item",
  thereAreMoreFiltersItems_plural: "There are {{count}} more items",
  thereWasAProblemWithDeletingTheSignatureKey:
    "There was a problem with deleting the signature key {{name}}. Please try again.",
  thereWasAProblemWithGenerating:
    "There was a problem with generating a new key pair. Please try again.",
  theTokenIoGeneratedIdentifierForTheParentSubTpp:
    "The Token.io-generated identifier for the parent sub-TPP. Please check Token documentation as a reference.",
  theUsernameAndPasswordIdentify:
    "The username and password identify your organisation, allowing you to access your data, request payments, process refunds and payouts, and access reports.",
  theUsernameAndPasswordIdentifyYourOrganisation:
    "The username and password identify your organisation, allowing you to access your data, request payments, process refunds and payouts, and access reports. Please do not share them with anyone.",
  thisAccountDeactivatingOn: "This account is deactivating on",
  thisConfigurationIsCommonForTokenAndVoltLicence:
    "This configuration is common for Token and Volt licence.",
  thisConfigurationIsCommonForTokenAndVoltLicenceDataForGivenMerchant:
    "This configuration is common for Token and Volt licence. Data for the given merchant has been already provided.",
  thisCustomerDoesNotHaveAddress: "This customer doesn't have an address",
  thisCustomerDoesNotHaveAddressContactSupport:
    "This customer doesn't have an address, to add this information, please ",
  thisCustomerDoesNotHaveDynamicTalkSupport:
    "This customer does not have any dynamic beneficiaries set up right now, talk to customer support team if you think there’s an issue",
  thisCustomerDoesNotHaveSelectedCountries:
    "This customer does not have selected countries from which payments are accepted.",
  thisDataCanBeUsedToMakePayments:
    "These data can be used to make payments from your Volt Account. Please do not share this with anyone.",
  thisParentDoesntHaveBankAccountsAssigned:
    "This parent doesn’t have any bank accounts assigned.",
  toAddANewKeyCredentialsNeedsToBeGeneratedFirst:
    "To add a new key, credentials needs to be generated first.",
  transformer: "Transformer",
  transformerRecognisesAShopperBank:
    "Transformer recognises a shopper’s bank based on their debit or bank-issued credit card’s first six to eight digits (BIN). It’s then able to facilitate a ‘switch’ from a card payment to an open banking payment.",
  type: "Type",
  unknown: "Unknown",
  uploadANewKey: "Upload a new key",
  uploadAnExistingPublicKey: "Upload an existing public key",
  uploadAPublicKey: "Upload a public key",
  us: "United States",
  usePublicKeyYouAlreadyHave:
    "Use a public key you already have. Make sure you have the matching private key to sign your refund and payout requests.",
  usePublicKeyYouAlreadyHaveMakeSureYouHaveTheMatchingPrivateKey:
    "Use a public key you already have. Make sure you have the matching private key.",
  username: "Username",
  useThePrivateKeyToSignAllRefundAndPayoutRequests:
    "Use the private key to sign all refund and payout requests. The public key will be used to validate your signature.",
  validationFailedIcon: "Validation failed icon",
  validationSuccessfulIcon: "Validation successful icon",
  verify: "Verify",
  verifyEnablesYouToSecurelyAccessCustomerBankAccounts:
    "Verify enables you to securely access customer bank accounts to confirm a user’s full name and account number. Compared to manual processes and working with unstructured data, it’s faster, more affordable and saves valuable time.",
  view: "View",
  voltAdminUser: "Volt admin user",
  voltCredentials: "Volt credentials",
  voltCustomerId: "Volt Customer ID",
  voltGatewayOurCoreAPIisTheStartingPointForReceivingPaymentsOnYourWebsiteOrApp:
    "Volt Gateway, our core API, is the starting point for receiving payments on your website or app. Whether you’re planning to receive money direct to your own bank account, or use the power of Volt Connect, our cash management service, this is the first integration point.",
  voltGeneratedKeyPair: "Volt-generated key pair",
  voltLicenceHasBeenDisabled: "Volt PIS license has been disabled",
  voltLicenceHasBeenEnabled: "Volt PIS license has been enabled",
  voltLicenceManagementAvailableOnYapilyAndPowerGrid:
    "Volt PIS license management is available on Yapily and PowerGrid only. To process transactions on a Volt PIS license, you need to firstly enable Yapily or PowerGrid on a Payment providers list.",
  voltPisLicence: "Volt PIS license",
  voltStoresThePublicKeyAndId:
    "Volt stores the public key and ID, but never the private key. Viewing the private key will not be possible after closing this pop-up.",
  vx2: "VX2",
  weWereNotAbleToActivate:
    'We were not able to activate Token. The following error has been received: "AWAITING_APPROVAL". Please, contact Token Support.',
  yesSetActive: "Yes, Set Active",
  yesSetInactive: "Yes, Set Inactive",
  youCanIssueARefundForEachPayment:
    "You can issue a refund for each payment received on your Volt Connect account. Refunds are available for up to a year from the original payment date. The refund will always be sent to the bank account that originated the payment and it will be sent from your current Volt Connect account in the currency of the payment.",
  youCanOnlyAddUpTo:
    "You can only add up to {{maxBeneficiaries}} beneficiaries at a time",
  youCurrentlyHaveSelectedCustomer:
    "You currently have a selected customer applied that is limiting the customers type you see. To view all customers type, please clear the filter.",
  youDoNotHavePermissionToManage:
    "You do not have permission to manage bank accounts. Contact Volt administrator if you think there is an error.",
  youDoNotHavePermissionToViewOrManage:
    "You do not have permissions to view or manage bank accounts. Contact Volt administrator if you think there is an error.",
  youDontHaveAnyDynamicBeneficiariesGetStarted:
    "You don’t have any dynamic beneficiaries set up right now, let’s get started",
  youDontHaveAnyPublicKeyUploadedYet:
    "You don't have any public key uploaded yet",
  youHaveUnsavedFilters: "You have unsaved filters",
  yourAddressDataIsMissing:
    "Your address data is missing. Please contact Volt Support for more details.",
};
